<template>
  <div class="bto-sb-element">
    <iframe
      ref="zoom"
      :src="zoomSoccerUrl"
      width="100%"
      scrolling="yes"
      frameborder="0"></iframe>
  </div>
</template>

<script>
  import { getZoomUrl } from 'bto-models/match/zoom';
  export default {
    name: 'ZoomSoccerComponent',
    props: {
      betRadarId: {
        type: [Number, String],
        required: true,
      },
      tournamentName: {
        type: String,
      },
      isLive: {
        type: Boolean,
        default: false,
      },
    },
    created() {
      window.addEventListener('message', this.resize);
    },
    destroyed() {
      window.removeEventListener('message', this.resize);
    },
    computed: {
      zoomSoccerUrl() {
        return getZoomUrl(this.betRadarId, this.tournamentName, this.isLive);
      },
    },
    methods: {
      resize(event) {
        if (event.data.type === "resizeWidget") {
          const size = event.data.value;
          this.$refs.zoom.setAttribute('height', `${size}px`);
        }
      },
    },
  };
</script>
